import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { first, map } from 'rxjs/operators';

const EMAIL_REGEXP =
    /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export class EmailValidators {

    static commaEmails(): ValidatorFn {

        return (control: AbstractControl): ValidationErrors | null => {
            if(control.value === null || control.value.length === 0){
                return null;
            }

            let valid = true;

            String(control.value).split(',').forEach(email => {
                if(!EMAIL_REGEXP.test(email)){
                    valid = false;
                }
            });

            return valid ? null : {'comma_email': true};
        };


    }

    static commaSeparatedEmailsWithSpaces(debounceMs: number = 500): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) return null;

            const emails: string[] = control.value.split(',').map((email: string) => email.trim()).filter((email: string) => email !== '');

            const forbidden = emails.some(email => {
                const mockControl = { value: email } as AbstractControl;
                return Validators.email(mockControl) !== null;
            });

            return forbidden ? { 'emails': { value: control.value }} : null;
        }
    }
}